import api from './api';
import type { Product, PaginatedResponse } from '../types';

interface ListProductsParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
  includeInactive?: boolean;
}

interface CreateProductInput {
  name: string;
  description?: string;
}

interface UpdateProductInput {
  name?: string;
  description?: string;
  isActive?: boolean;
}

export async function listProducts(params: ListProductsParams = {}): Promise<PaginatedResponse<Product>> {
  const response = await api.get<PaginatedResponse<Product>>('/products', { params });
  return response.data;
}

export async function getActiveProducts(): Promise<{ id: string; name: string; description?: string }[]> {
  const response = await api.get<{ id: string; name: string; description?: string }[]>('/products/active');
  return response.data;
}

export async function getProduct(id: string): Promise<Product> {
  const response = await api.get<Product>(`/products/${id}`);
  return response.data;
}

export async function createProduct(data: CreateProductInput): Promise<Product> {
  const response = await api.post<Product>('/products', data);
  return response.data;
}

export async function updateProduct(id: string, data: UpdateProductInput): Promise<Product> {
  const response = await api.put<Product>(`/products/${id}`, data);
  return response.data;
}

export async function deleteProduct(id: string): Promise<void> {
  await api.delete(`/products/${id}`);
}
